import {
  Bell,
  Check,
  Globe,
  Home,
  Keyboard,
  Link,
  Lock,
  Menu,
  MessageCircle,
  Paintbrush,
  Settings,
  Video,
  UserRound,
  Ticket,
  CalendarCheck,
  ClipboardCheck,
  Package,
  RefreshCw,
  File,
  FileText,
  FileImage,
  Pill,
  DollarSign,
  Clock,
} from "lucide-react";

export const NAVIGATION_DATA = {
  settings: [
    { name: "Notifications", icon: Bell },
    { name: "Navigation", icon: Menu },
    { name: "Home", icon: Home },
    { name: "Appearance", icon: Paintbrush },
    { name: "Messages & media", icon: MessageCircle },
    { name: "Language & region", icon: Globe },
    { name: "Accessibility", icon: Keyboard },
    { name: "Mark as read", icon: Check },
    { name: "Audio & video", icon: Video },
    { name: "Connected accounts", icon: Link },
    { name: "Privacy & visibility", icon: Lock },
    { name: "Advanced", icon: Settings },
  ],
  contacts: [
    { name: "Information", icon: UserRound },
    { name: "Timeline", icon: Clock },
    { name: "Tickets", icon: Ticket },
    { name: "Events", icon: CalendarCheck },
    { name: "Eligibility", icon: ClipboardCheck },
    { name: "Device orders", icon: Package },
    { name: "Encounters", icon: RefreshCw },
    { name: "Files", icon: File },
    { name: "Forms", icon: FileText },
    { name: "Content", icon: FileImage },
    { name: "Medications", icon: Pill },
    { name: "Payment", icon: DollarSign },
  ],
} as const;
